import { SIGNUP_FAILURE, SIGNUP_SUCCESS, TEACHER_DETAILS_FAILURE, TEACHER_DETAILS_SUCCESS, USER_DETAILS_FAILURE, USER_DETAILS_SUCCESS, USERLIST_FAILURE, USERLIST_SUCCESS, USERS_LIST_FAILURE, USERS_LIST_SUCCESS } from "./auth.actionTypes";

const initialState = {
  signupData: null,
  userDetails: null,
  teacherDetails: null,
  usersList: null,
  message: null
};

export default function AuthReducer(state = initialState, { type, payload }) {
  switch (type) {
    case SIGNUP_SUCCESS:
      return {
        ...state,
        signupData: payload.data,
      };
    case SIGNUP_FAILURE:
      return {
        ...state,
        message: payload.message,
      };

         case USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: payload,
      };
    case USER_DETAILS_FAILURE:
      return {
        ...state,
        message: "",
      };

    case TEACHER_DETAILS_SUCCESS:
      return {
        ...state,
        teacherDetails: payload,
      };
    case TEACHER_DETAILS_FAILURE:
      return {
        ...state,
        message: "",
      };

    case USERS_LIST_SUCCESS:
      return {
        ...state,
        usersList: payload,
      };
    case USERS_LIST_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
